







































































import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";

import Close from "../resources/close.vue";
import DisplayPassword from "../resources/displayPassword.vue";

@Component({
  components: {
      Close,
      DisplayPassword
  }
})

export default class SignUp extends Vue {
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    isLook = false;
    isCanSubmit = false;

    private mail = "";
    private password = "";
    private rePassword = "";

    private mounted(){
        (this.$refs.mail as HTMLElement).focus();
    }

    private onDoCommand(command : string, param : any){
        this.$emit("doCommand", command, param);
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.mail == "" || this.password == "" || this.rePassword == ""){ return; }
        this.registration();
    }

    private returnPage(){
        this.onDoCommand("returnPage", null);
    }

    private registration(){
        var param = {
            mail : this.mail,
            password : this.password,
            rePassword : this.rePassword,
            installId : CookieHelper.getItem("installId")
        }
        this.onDoCommand("signUp", param);
    }

    private get changeLook(){
        return this.isLook ? "text" : "password";
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }
}
